import type { Platform, SocialDateValue, SocialStatsDto } from "shared";

type DictDate = string;

type OmitedSocialDateValue = Omit<SocialDateValue, "date">;

type DictionarySocialValue = Record<Platform, OmitedSocialDateValue>;

type DictionarySocialStats = Record<DictDate, DictionarySocialValue>;

export const getDictionaryFromData = (
	data: Partial<SocialStatsDto>,
): DictionarySocialStats => {
	const platforms = Object.keys(data) as Array<Platform>;

	const dict = platforms.reduce<DictionarySocialStats>((accDates, platform) => {
		for (const value of data[platform] ?? []) {
			const { date, ...rest } = value;
			accDates[date] = {
				...accDates[date],
				[platform]: rest,
			};
		}

		return accDates;
	}, {});

	return dict;
};

export const sumDictionaryData = (
	dict: DictionarySocialStats,
): Array<SocialDateValue> => {
	const keysToSum = [
		"followers",
		"likes",
		"comments",
		"shares",
		"impressions",
	] as const;

	return Object.entries(dict).reduce<Array<SocialDateValue>>(
		(acc, dictEntry) => {
			const [data, dictObject] = dictEntry;
			const objectArray = Object.values(dictObject);

			const summed = objectArray.reduce(
				(accumulatorObject, currentObject) => {
					for (const key of keysToSum) {
						const current = accumulatorObject[key] ?? 0;
						const entry = currentObject[key] ?? 0;

						accumulatorObject[key] = current + entry;
					}

					return accumulatorObject;
				},
				{
					followers: 0,
					likes: 0,
					comments: 0,
					shares: 0,
					impressions: 0,
				},
			);

			acc.push({ ...summed, date: data });

			return acc;
		},
		[],
	);
};
